import { ButtonNew, SpacerNew } from '@jfs/ui-new'
import { useCallback } from 'react'
import { Container } from '../../../comps/Container'
import { Screens } from '../../../nav/Screens'

const MoneyTransferHomeScreen = ({ navigation }: any) => {
  const onTransactionHistoryPress = useCallback(
    () => navigation?.navigate(Screens.DOMESTIC_MONEY_TRANSACTIONS_SCREEN),
    [navigation],
  )
  const onInitiateDMTTransactionPress = useCallback(
    () => navigation?.navigate(Screens.DOMESTIC_MONEY_TRANSFER_LOGIN),
    [navigation],
  )

  return (
    <Container showFooter={true} type="refund" title={''}>
      <ButtonNew
        onPress={onInitiateDMTTransactionPress}
        title={'Initiate DMT Transaction'}
        type={'primaryFullWidth'}
        height={42}
      />
      <SpacerNew size={20} />
      <ButtonNew
        onPress={onTransactionHistoryPress}
        title={'Transaction History'}
        type={'secondaryFullWidth'}
        borderColor={'PRIMARY'}
        height={42}
      />
    </Container>
  )
}

export default MoneyTransferHomeScreen
